import { createMarkdownSanitizeSchema } from "@next-platform/client-common-core/utils/markdownSanitizeSchema";
import type { Options } from "rehype-sanitize";

/**
 * Web Markdown sanitize schema.
 *
 * The shared allowlist lives in `common-core`. Only the extras that this app's
 * preprocessor (`preprocessContent` / `formatInstructionCommandsV2`) produces
 * belong here:
 * - `<aside role>` — the command bar, injected by formatInstructionCommandsV2.
 * - `div` `aria-label` / `data-has-clean-content` — read by the command-bar div renderer.
 */
const markdownSanitizeSchema: Options = createMarkdownSanitizeSchema({
  tagNames: ["aside"],
  attributes: {
    aside: ["role"],
    div: ["ariaLabel", "dataHasCleanContent"],
  },
});

export default markdownSanitizeSchema;
